module.exports = __webpack_public_path__ + "static/media/luna.63f7f6fb.png";